import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ActivityEdit } from './components';
import moment from 'moment';
import snakeToCamel from 'utils/snakeToTitle';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const ActivityInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.activity);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    setOpenEdit(true);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Activity Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Title</TableCell>
              <TableCell>{model.title}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Timestamp</TableCell>
              <TableCell>{moment(model.timestamp).format("DD/MM/YYYY - HH:mm")}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Content</TableCell>
              <TableCell>{model.content}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Status</TableCell>
              <TableCell>{snakeToCamel(model.status)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <ActivityEdit onClose={handleEditClose} open={openEdit} />
    </Card>
  );
};

ActivityInfo.propTypes = {
  className: PropTypes.string,
};

export default ActivityInfo;
